import { defineMessages } from 'react-intl';

export default defineMessages({
    PolicyStart: {
        id: 'policycommon.component.policy-common-details.Policy Effective',
        defaultMessage: 'Policy Effective'
    },
    PolicyExpiration: {
        id: 'policycommon.component.policy-common-details.Policy Expiration',
        defaultMessage: 'Policy Expiration'
    },
    PolicyType: {
        id: 'policycommon.component.policy-common-details.Producer Code',
        defaultMessage: 'Producer Code'
    },
    policyStatus: {
        id: 'policycommon.component.policy-common-details.Policy Status',
        defaultMessage: 'Policy Status'
    },
    TotalPremium: {
        id: 'policycommon.component.policy-common-details.Total Premium',
        defaultMessage: 'Total Premium'
    },
    TaxesAndFees: {
        id: 'policycommon.component.policy-common-details.Taxes and Fees',
        defaultMessage: 'Taxes and Fees'
    },
    Taxes: {
        id: 'policycommon.component.policy-common-details.Taxes',
        defaultMessage: 'Taxes'
    },
    Fees: {
        id: 'policycommon.component.policy-common-details.Fees',
        defaultMessage: 'Fees'
    },
    TotalCost: {
        id: 'policycommon.component.policy-common-details.Total Cost',
        defaultMessage: 'Total Cost'
    },
    // commonDetailsSection: {
    //     id: 'policycommon.component.policy-common-details.Details',
    //     defaultMessage: 'Details for {polNumber}'
    // },
    // premium: {
    //     id: 'policycommon.component.policy-common-details.Premium',
    //     defaultMessage: 'Premium'
    // },
    // active: {
    //     id: 'policycommon.component.policy-common-details.Active',
    //     defaultMessage: 'Active'
    // }
    totalPremium: {
        id: 'policycommon.component.policy-common-details.Premium',
        defaultMessage: 'Premium'
    },
});
